import { Stack } from "@chakra-ui/react";
import React from "react";
import CustomizationForm from "./CustomizationForm";
import ChatWidget from "./ChatWidget";

export default function WidgetCustomizationV1({
  onChangeWidgetCustomizationOption,
  setWidgetCustomizationOptions,
  buttons,
  setButtons,
  widgetCustomizationOptions,
  userOpeningMessages,
  setUserOpeningMessages,
  handleOnLoad,
  handleOnWidgetUpdate,
}) {
  return (
    <Stack
      direction="row"
      justifyContent={"space-between"}
      spacing={2}
      h={"100%"}
      w={"100%"}
    >
      <CustomizationForm
        onChangeWidgetCustomizationOption={onChangeWidgetCustomizationOption}
        setWidgetCustomizationOptions={setWidgetCustomizationOptions}
        buttons={buttons}
        setButtons={setButtons}
        widgetCustomizationOptions={widgetCustomizationOptions}
        userOpeningMessages={userOpeningMessages}
        setUserOpeningMessages={setUserOpeningMessages}
        handleOnLoad={handleOnLoad}
      />

      <ChatWidget
        buttons={buttons}
        widgetCustomizationOptions={widgetCustomizationOptions}
        userOpeningMessages={userOpeningMessages}
        handleOnWidgetUpdate={handleOnWidgetUpdate}
      />
    </Stack>
  );
}
